import React from 'react';
import Search from 'components/users/Search';
import Users from 'components/users/Users';

const Home = () => (
  <>
    <Search />
    <Users />
  </>
);

export default Home;
